import { createContext, useContext } from 'react';

export interface AdminAuthContextValue {
  isAdminAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  login: (password: string, totpCode?: string) => Promise<void>;
  logout: () => Promise<void>;
  clearError: () => void;
  handleUnauthorized: () => void;
}

export const AdminAuthContext = createContext<AdminAuthContextValue | null>(null);

export function useAdminAuth(): AdminAuthContextValue {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
}
